<template>
  <div id="app" ref="app" class="app">
    <HeaderWrap></HeaderWrap>
    <div class="container" ref="cont">
      <LeftBar></LeftBar>
      <router-view/>
    </div>
  </div>
</template>

<script>
  import HeaderWrap from 'components/header.vue'
  import LeftBar from 'components/leftBar';

  export default {
    name: 'app',
    computed: {

    },
    mounted() {

    },
    watch: {

    },
    methods: {

    },
    components: {
      HeaderWrap,
      LeftBar
    }
  }
</script>

<style lang="scss">
  .app {
    width: 100%;
    min-width: 1280px;
    min-height: 770px;
    margin-top: 80px;
    box-sizing: border-box;
    .container {
      width: 100%;
      min-width: 1280px;
      /*height: calc(100% - 0px);*/
      /*background-color: #071310;
      background: url("./assets/img/main_bg.jpg") no-repeat center;*/
      background-size: cover;
      display: flex;
      justify-content: flex-start;
      > div:nth-child(1) {
        flex-shrink: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue